import React from "react";
import Mountain1 from "../assets/1.webp";
import Mountain2 from "../assets/2.jpg";
import Mountain3 from "../assets/5.webp";
import Mountain4 from "../assets/8.webp";
import DestinationData from "./destinationdata";

const Destination = () => {
  return (
    <>
      <div className="destination obj-width">
        <h1>Popular Destinations</h1>
        <p>Tours give you the opportunity to see a lot, within a time frame.</p>
        <DestinationData
          className="first-des"
          heading="Hunza Valley, Gilgit-Baltistan"
          text="Hunza Valley offers one of the most breathtaking views in Pakistan's northern regions. Surrounded by majestic mountains, this picturesque valley features stunning landscapes and crystal-clear rivers. A popular trek is the hike up to Altit Fort, providing panoramic views of the Hunza River and the valley. The hike is relatively easy and suitable for beginners, with guides available. Discover charming villages and traditional architecture as you explore. End your adventure with a traditional Hunza meal before heading back home!"
          img1={Mountain1}
          img2={Mountain2}
        />

        <DestinationData
          className="first-des-reverse"
          heading="Naran-Kaghan, Khyber Pakhtunkhwa"
          text="For a moderately challenging hike that's perfect for beginner mountaineers, explore the Naran-Kaghan region in Khyber Pakhtunkhwa. Begin your trek from the scenic Naran Valley, where you'll navigate through lush forests, rocky paths, and picturesque meadows. Enjoy rest stops along the way with stunning views of the surrounding landscapes. Although the summit might not offer expansive vistas, the refreshing mountain breeze is invigorating. After your hike, take time to unwind in the natural beauty of the Naran-Kaghan region and enjoy its serene environment.

"
          img1={Mountain3}
          img2={Mountain4}
        />
      </div>
    </>
  );
};

export default Destination;


